// extracted by mini-css-extract-plugin
export default {"nhima-header":"Header_nhima-header__cPbSf","nhima-header__buttons":"Header_nhima-header__buttons__1txjl"};